import $ from 'jquery';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';
import confirmDialog from '@/js/modules/confirm_dialog';

onPageLoad(() => {
  // tab, shift, alt, ctrl or arrow keys

  const metaKeys = (keyCode) => [9, 16, 17, 18, 37, 38, 39, 40].includes(keyCode);

  function openAjaxModal(url) {
    $.ajax({
      url,
      success(newHTML) {
        $(newHTML).appendTo('body').modal();
      },
    });
  }

  class AppAndEditor {
    static initialize() {
      // additional way of creating jQuery modals when we do not need .modal div wrapper (as it's already included in the partial)
      $(document).on('click.modal', 'a[rel~="modal:ajax-open"]', (e) => {
        openAjaxModal($(e.currentTarget).attr('href'));

        return false;
      });

      $(document).on('click.modal', 'a[rel~="modal:iframe-open"]', (e) => {
        const $target = $(e.currentTarget);
        const $modal = $('<div class="modal modal--iframe-open" />');
        const $modalBody = $('<div class="modal__preview" />');
        const $modalBodyIframe = $('<iframe class="modal__preview-iframe" />');
        const url = $target.attr('href');

        $modalBodyIframe.attr('src', url);
        $modalBodyIframe.appendTo($modalBody);
        $modalBody.appendTo($modal);
        $modal.appendTo('body').modal();

        // Resize iframe to fit content
        if ($target.data('fit-content') === 'yes') {
          $modalBodyIframe.on('load', () => {
            $modalBodyIframe.css('height', $modalBodyIframe.contents().height());
          });
        }

        return false;
      });

      $(document).on($.modal.CLOSE, (_, modal) => {
        const $modal = $(modal.elm);

        if ($modal.hasClass('modal--iframe-open')) {
          $modal.remove();
        }
      });

      $(document).on($.modal.OPEN, (_, modal) => {
        const $modal = $(modal.elm);
        $('.jquery-modal').css({ opacity: 1 });
        $modal.find('input[autofocus]').trigger('focus');
      });

      $(document).on(
        'change keyup paste input',
        '.field--shoppable-unit-price, .field--shoppable-markup, .field--shoppable-client-price',
        (e) => {
          if (metaKeys(e.keyCode)) {
            return;
          }

          const $field = $(e.target);
          const $form = $field.closest('.bookmarklet-form');
          const $unitPriceField = $form.find('.field--shoppable-unit-price');
          const $markupField = $form.find('.field--shoppable-markup');
          const $clientPriceField = $form.find('.field--shoppable-client-price');

          const unitPriceCents = parseFloat($unitPriceField.val()) * 100 || 0;

          let clientPriceCents;
          // when modifying client price field - calculate and set markup
          if ($field.is('.field--shoppable-client-price')) {
            clientPriceCents = parseFloat($field.val()) * 100 || 0;

            if (unitPriceCents <= clientPriceCents && unitPriceCents > 0) {
              const markupPercentage = (clientPriceCents - unitPriceCents) / unitPriceCents;
              $markupField.val((markupPercentage * 100).toFixed(2));
            }
          } else {
            // when modifying unit price or markup - calculate and set client price
            const markupPercentage = parseFloat($markupField.val()).toFixed(2) / 100 || 0;
            clientPriceCents = unitPriceCents + unitPriceCents * markupPercentage;

            $clientPriceField.val((clientPriceCents / 100).toFixed(2));
          }

          if (unitPriceCents > clientPriceCents) {
            $clientPriceField.addClass('field--error');
            $form.find('.error-message--price').show();
            $form.find('button').attr('disabled', true);
          } else {
            $clientPriceField.removeClass('field--error');
            $form.find('.error-message--price').hide();
            $form.find('button').attr('disabled', false);
          }
        }
      );
    }
  }

  // upload item - project dropdown
  $(document).on('click', '.projects-dropdown__label-text', () => {
    if ($('.projects-dropdown__dropdown:visible').length) {
      $('.projects-dropdown__dropdown').hide();
    } else {
      $('.projects-dropdown__dropdown').slideDown('fast', () => {
        $('.field--projects-dropdown-search').focus();
      });
    }
  });

  $(document).on('change', '.projects-dropdown input[type="checkbox"]', () => {
    let val = $('.projects-dropdown :checked')
      .map(function () {
        return $(this).data().title;
      })
      .get()
      .join(', ');
    if (val === '') {
      val = 'Please select project';
    }

    $('.projects-dropdown__label-text').html(val);
  });

  $(function () {
    $('.modal--first-time-in-editor').modal();
  });

  $(document).on('turbo:frame-load', '#vendor_form', (e) => {
    const frame = e.target;
    const $companyName = $(frame).find('.autocomplete-company-name');

    if ($companyName.length) {
      const renderItem = (ul, item) => {
        return $('<li>').append(`<div>${item.label}</div>`).appendTo(ul);
      };

      $companyName
        .autocomplete({
          source(request, response) {
            $.ajax({
              url: '/vendors/xhr_company_names',
              data: { q: request.term },
              success(data) {
                response(data);
              },
            });
          },
          minLength: 2,
          async select(event, ui) {
            const edit = await confirmDialog(
              "Would you like to view and edit the existing vendor's details instead?",
              {
                title: `Vendor '${ui.item.value}' Already Exists`,
                button: 'Edit Vendor',
                danger: false,
              }
            );

            if (!edit) {
              return;
            }

            // Same query, so the edit form keeps the Generate POs or PO select context of the new one.
            const url = new URL(frame.src, window.location.href);
            url.pathname = `/vendors/${ui.item.id}/edit`;
            $companyName.autocomplete('destroy');
            frame.src = url.href;
          },
        })
        .autocomplete('instance')._renderItem = renderItem;
    }
  });

  // Add New Vendor starts the vendor form with what was typed in the vendor search.
  $(document).on(
    'input',
    '[data-vendors--search-select] [data-ui--search-select-target="search"]',
    (e) => {
      const link = e.target
        .closest('[data-vendors--search-select]')
        .querySelector('.js-add-vendor');
      const url = new URL(link.href);
      const companyName = e.target.value.trim();

      if (companyName) {
        url.searchParams.set('new_company_name', companyName);
      } else {
        url.searchParams.delete('new_company_name');
      }
      link.href = url.href;
    }
  );

  // Renaming through Edit Vendor moves the vendor selects that had the old name picked to the new one.
  $(document).on('turbo:submit-end', '#vendor_form form', ({ target: form, detail }) => {
    const companyName = form.elements['vendor[company_name]'];

    if (
      !detail.success ||
      !form.elements.from_search_select ||
      form.elements._method?.value !== 'patch'
    ) {
      return;
    }

    document.querySelectorAll('[data-vendors--search-select]').forEach((select) => {
      const input = select.querySelector('[data-ui--search-select-target="input"]');

      if (input.value === companyName.defaultValue) {
        input.value = companyName.value;
        select.querySelector('[data-ui--search-select-target="label"]').textContent =
          companyName.value;
      }
    });
  });

  $(document).on('ui--twin-turbo-modal:close', 'dialog:has(#vendor_form)', (e) => {
    $(e.target).find('.autocomplete-company-name').autocomplete('destroy');
  });

  $('html').click(function (e) {
    const $target = $(e.target);
    if (
      !$target.is('.projects-dropdown__dropdown *') &&
      !$target.is('.projects-dropdown__label-text')
    ) {
      $('.projects-dropdown__dropdown').hide();
    }
  });

  AppAndEditor.initialize();
});
